import React, { createContext, useContext, useState } from 'react';

const SleeperModalContext = createContext();

export const useSleeperModal = () => {
  const context = useContext(SleeperModalContext);
  if (!context) {
    throw new Error('useSleeperModal must be used within a SleeperModalProvider');
  }
  return context;
};

export const SleeperModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <SleeperModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </SleeperModalContext.Provider>
  );
};
